"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _toolBase = require("@futuweb/tool-base");
var browser = _interopRequireWildcard(require("@futuweb/tool-browser"));
var _nn = _interopRequireDefault(require("./nn"));
var _schema = _interopRequireDefault(require("./schema"));
var Utils = _interopRequireWildcard(require("./utils"));
var _cloneDeep = _interopRequireDefault(require("lodash/cloneDeep"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**!
 *
 * @author   alanzhang
 * @date     2016/07/22
 * @overview H5 牛牛圈与native IOS，Android的通信；以后更多的扩展也可在此处扩展
 */

var prototacal = browser.isMoomoo() ? 'futumm' : 'futunn';

// schema值索引
var schemaMap = {
  //页面载入完成
  loadBridge: prototacal + '://jsBridge/bridge_loaded'
};

// 评论类型
var CommentActionType = {
  // 回复feed
  replyToFeed: 'ReplyToFeed',
  // 回复别人的评论
  replyToComment: 'ReplyToComment'
};
var pageData = null;
var filterChannel = Utils.filterChannel;
var _genID = Utils.genIdWrapper('base64_');
var _isBase64 = Utils.isBase64;
var _findChannelById = Utils.findChannelById;
var NNQ = {
  bridge: null,
  isInit: false,
  // 默认需要注册的H5函数,由Native调用
  _H5FunctionMap: {
    /**
     * [载入页面后获取上下文页面信息]
     * @param  {[type]} data             [description]
     * @param  {[type]} responseCallback [description]
     * @return {[type]}                  [description]
     */
    'fetchContextPageInfo': function fetchContextPageInfo(data, responseCallback) {
      data = data || {
        url_now: window.location.href
      };

      // pageData 在initBridge中进行了保存,同时为了防止this指向问题，在外部环境中也保存了pageData
      typeof responseCallback === 'function' && responseCallback(pageData);
    }
  },
  /**
   * [initBridge 初始化iframe，通知native注入webbridge对象，注册H5端函数供native使用]
   * @param  {JSON} data  [
   * {
   *     'page_now':'index',
   *     'page_urls':[url1,url2....]
   * ]
   * @param {function} readyFunction bridge加载完的回调，传入的参数是this
   * @return {[Object]}     返回一个promise，resolve返回的是this
   */
  initBridge: function initBridge(data, readyFunction) {
    var that = this;
    // window.NNWebViewJSBridge 加载好的时候的回调
    var initJSBridge = function initJSBridge() {
      if (!that.isInit) {
        // 保存NNWebViewJSBridge对象
        that.bridge = window.NNWebViewJSBridge;

        // 注册方法
        that.registerH5Function(that._H5FunctionMap);
        that.isInit = true;
      }
      // 放置在that.bridge赋值之后再执行，其他api依赖bridge赋值
      readyFunction && readyFunction(that);
    };

    // 进入页面立即执行的操作
    var initEvent = function initEvent() {
      if (!browser.isMobileNN()) {
        return;
      }
      // 初始化H5方法时所需参数
      that.pageData = data || {
        'page_now': '0',
        'page_urls': []
      };
      pageData = that.pageData;

      // 通知native注入NNWebViewJSBridge对象，如果电脑电脑端安装了牛牛客户端，会弹窗提示打开牛牛
      _schema["default"].loadSchema(schemaMap['loadBridge'], null, function () {
        setTimeout(function () {
          _schema["default"].destorySchemaIfr();
        }, 1000);
      });
    };
    if (!that.isInit) {
      initEvent();
    }
    return new Promise(function (resolve, reject) {
      if (!browser.isMobileNN()) {
        // reject(new Error('请在牛牛客户端内打开！'));
        return;
      }

      // 如果已经主如果NNWebViewJSBridge对象，直接执行回调方法
      if (window.NNWebViewJSBridge) {
        // 执行ready回调
        initJSBridge();
        resolve(that);
      } else {
        // 给native注入webridge预留时间
        var _timer = setInterval(function () {
          if (window.NNWebViewJSBridge) {
            clearInterval(_timer);
            initJSBridge();
            resolve(that);
          }
        }, 100);
      }
    });
  },
  /**
   * [registerH5Function 注册H5端的函数，供Native端使用]
   * @funMap  {JSON}    [函数列表，格式为{funName:funtionBody} ]
   * @return  {[type]}  [description]
   */
  registerH5Function: function registerH5Function(funMap) {
    var that = this;
    for (var funName in funMap) {
      if (Object.prototype.hasOwnProperty.call(funMap, funName)) {
        that.bridge.registerHandler(funName, funMap[funName]);
      }
    }
  },
  /**
   * [showBigPic 点击Web详情页图片调用Native图片浏览工具，做大图浏览]
   * @param  {JSON} data                [
   *    {
   *    'pic_index':'num',                 // 在pic_urls数组中的索引，0开始，表示显示第几张图片，
   *    'pic_urls':['url_01','url_02',...] // 要显示大图的url
   *    }
   * ]
   * @param  {Function} successCallback [description]
   * @param  {Function} failCallback    [description]
   * @return {[type]}                 [description]
   */
  showBigPic: function showBigPic(data, successCallback, failCallback) {
    this.bridge.callHandler('bigPicDidClicked', data, function (responseData) {
      if (typeof responseData === 'string') {
        responseData = JSON.parse(responseData);
      }
      if (+responseData.result === 0) {
        typeof successCallback === 'function' && successCallback();
      } else {
        typeof failCallback === 'function' && failCallback();
      }
    });
  },
  /**
   * [replyToFeed 评论feed]
   * @param  {[type]} data  [
   * {
   *     feedid:feedid
   * }
   * ]
   * @param  {Function} successCallback [成功时的回调函数]
   * @param  {Function} failCallback    [失败时的回调函数]
   * @return {[type]}                  [description]
   */
  replyToFeed: function replyToFeed(data, successCallback, failCallback) {
    data.type = CommentActionType.replyToFeed;
    this.replayComment(data, successCallback, failCallback);
  },
  /**
   * [replyToComment 回复评论]
   * @param  {[type]} data   [
   * {
   *     feedid:feedid,
   *     commentid:"commentid",
   *     replyUserName:"这条评论的回复者"
   * }
   * ]
   * @param  {Function} successCallback [成功时的回调函数]
   * @param  {Function} failCallback    [失败时的回调函数]
   * @return {[type]}                  [description]
   */
  replyToComment: function replyToComment(data, successCallback, failCallback) {
    data.type = CommentActionType.replyToComment;
    this.replayComment(data, successCallback, failCallback);
  },
  /**
   * [webPageDataLoaded web异步加载页面数据后主动通知native，触发native拿去页面信息动作]
   * @param  {Boolean} isloaded          [页面传给native的数据是否在页面端加载完成]
   * @param  {Function}  successCallback [方法调用成功时的回调]
   * @param  {Function}  failCallback    [方法调用失败时的回调]
   * @return {[type]}                    [description]
   */
  webPageDataLoaded: function webPageDataLoaded(isloaded, successCallback, failCallback) {
    var is_loaded = isloaded == true || isloaded === 'yes' ? 'yes' : 'no';
    this.bridge.callHandler('webPageDataLoaded', {
      isloaded: is_loaded
    }, function (responseData) {
      if (typeof responseData === 'string') {
        responseData = JSON.parse(responseData);
      }
      if (responseData.result == 0) {
        typeof successCallback === 'function' && successCallback();
      } else {
        typeof failCallback === 'function' && failCallback();
      }
    });
  },
  /**
   * [replayComment 点击web上feed或评论呼起Native评论框]
   * @param  {[type]} data             [description]
   * @param  {Function} successCallback [成功时的回调函数]
   * @param  {Function} failCallback    [失败时的回调函数]
   * @return {[type]}                  [description]
   */
  replayComment: function replayComment(data, successCallback, failCallback) {
    this.bridge.callHandler('callNativeCommentAction', data, function (responseData) {
      if (typeof responseData === 'string') {
        responseData = JSON.parse(responseData);
      }

      // 回复成功
      if (+responseData.result === 0) {
        typeof successCallback === 'function' && successCallback();
      } else {
        typeof failCallback === 'function' && failCallback();
      }
    });
  },
  /**
   * [setShareConfig H5同步native-根据channel支持配置多个分享项（影响右上角菜单）或显示title]
   * @param  {[type]} data
          {
          // 显示在顶部的title
          "show_title": "牛牛圈大件事",
          // 屏蔽的分享渠道，多个渠道需屏蔽时做|操作
          // disabled channel文档参看http://fservice.server.com/repository/project/1190057/proto-space/4691/main/-/setShareConfig.md?method_branch=main
          "disabled": 0x280,
          "share_data": {
          // common_model必续携带，不存在common_model.channel字段
          "common_model": {
              // 资讯标题
              "title": "标题",
              // 摘要
              "description": "这个是新闻摘要",
              // 跳转链接
              "url": "https://news.futunn.com/market/118221?src=3",
              // 图片
              "image_url": "https://postimg.futunn.com/2019080700000038e0bcca3d36b.jpg",
              // 自定义补充数据,非必须
              "ext": "额外数据",
              // 上报类型，1-个股资讯 2-新闻资讯，不传时为空
              "link_type": 1
          },
          // 其他渠道定制的分享配置（非必传）
          "share_model_list": [
              {
              // 资讯标题
              "title": "标题",
              // 描述
              "description": "这个是新闻摘要",
              // 跳转链接
              "url": "https://news.futunn.com/market/118221?src=3",
              // 分享图片地址
              "image_url": "https://postimg.futunn.com/2019080700000038e0bcca3d36b.jpg",
              // 自定义补充数据
              "ext": "额外数据",
              // 目前支持可配置三种渠道
              // 进制数|的结果
              "channel": 0x01,
              // 上报类型，1-个股资讯 2-新闻资讯，不传时为''
              "link_type": 1
              }
          ]
          },
          //分享动作执行完毕之后的回调
          "callback": '_toolnn_callback_8197755258' 
      }
      *
      *
      *
      * ]
      * @param  {Function} successCallback [成功时的回调函数]
      * @param  {Function} failCallback    [失败时的回调函数]
      * @return {[type]}                  [description]
      */
  configV2: function configV2(data, successCallback, failCallback) {
    var findChannelById = data._findChannelById || _findChannelById;
    this.bridge.callHandler('setShareConfig', data, function (responseData) {
      if (typeof responseData === 'string') {
        responseData = JSON.parse(responseData);
      }
      var channel = findChannelById(responseData.channel);
      // 回复成功
      if (+responseData.result === 0) {
        typeof successCallback === 'function' && successCallback(channel);
      } else {
        typeof failCallback === 'function' && failCallback(channel);
      }
    });
  },
  /**
   * [setShowShare H5同步native分享：直接触发牛牛弹出分享框]
   * @param  {[type]} data             [
   *
   * {
           // 屏蔽的分享渠道，多个渠道需屏蔽时做|操作
          //{
          // disabled channel文档参看http://fservice.server.com/repository/project/1190057/proto-space/4691/main/-/setShareConfig.md?method_branch=main
          "disabled": 0x280,
          "share_data": {
          // 必传
          "common_model": {
              // 资讯标题
              "title": "标题",
              // 摘要
              "description": "这个是新闻摘要",
              // 跳转链接
              "url": "https://news.futunn.com/market/118221?src=3",
              // 图片
              "image_url": "https://postimg.futunn.com/2019080700000038e0bcca3d36b.jpg",
              // 自定义补充数据,非必传
              "ext": "额外数据"
          },
          // 其他渠道定制的分享配置（非必传）
          "share_model_list": [
              {
              // 资讯标题
              "title": "标题",
              // 描述
              "description": "这个是新闻摘要",
              // 跳转链接
              "url": "https://news.futunn.com/market/118221?src=3",
              // 分享图片地址
              "image_url": "https://postimg.futunn.com/2019080700000038e0bcca3d36b.jpg",
              // 自定义补充数据
              "ext": "额外数据",
              // 进制数|的结果
              "channel": 0x01
              }
          ]
          },
          //分享动作执行完毕之后的回调
          "callback": '_toolnn_callback_8197755258' 
      }
      *
      *
      * ]
      * @param  {Function} successCallback [成功时的回调函数]
      * @param  {Function} failCallback    [失败时的回调函数]
      * @return {[type]}                  [description]
      */
  showShareV2: function showShareV2(data, successCallback, failCallback) {
    var findChannelById = data._findChannelById || _findChannelById;
    this.bridge.callHandler('setShowShare', data, function (responseData) {
      if (typeof responseData === 'string') {
        responseData = JSON.parse(responseData);
      }
      var channel = findChannelById(responseData.channel);

      // 回复成功
      if (+responseData.result === 0) {
        typeof successCallback === 'function' && successCallback(channel);
      } else {
        typeof failCallback === 'function' && failCallback(channel);
      }
    });
  },
  /**
   * [setMenuConfig NNQ设置WebView页面右上角菜单展示/隐藏 配置]
   * {
          "version" : 1,
          // showType 默认为0，与native合并显示内容；若为1，则覆盖显示内容；
          "showType" : 0,
          // 显示在右上角的Menu
          "actionMenu" : {
              // 白名单: 需要展示的列表
              "enable" : [
                  {
                      // item名称, 对应上面的表
                      "name" : "search",
                      // 展示位置，可以自定义，默认为0，按照上面的position值展示
                      "position" : 0
                  },
                  {
                      "name" : "more",
                      "position" : 0
                  }
              ],
              // 黑名单: 禁止展示的actionMenu列表；如果disable里有more, 则popupmenu内容不会被使用
              "disable" : [
                  {
                      "name" : "refresh",
                      "position": 0
                  }
              ]
          },
          // 三明治弹出窗口展示的列表
          "popupMenu" : {
              // 白名单: 三明治窗口 需要展示的列表
              "enable" : [
                  {
                      // item key, 对应上面的表
                      "name" : "im",
                      "position": 0
                  },
                  {
                      "name" : "favorite",
                      "position": 0
                  }
              ]
              //黑名单: 三明治窗口不需要展示的列表
              "disable" : [
                  {
                      "name" : "report",
                      "position": 0
                  }
              ]
          }
      }
      *
      * @return {[type]} [description]
      */
  setMenuConfig: function setMenuConfig(data) {
    var deepCloneData = (0, _toolBase.extend)({}, data, true);
    deepCloneData = this.initSetMenuConfigData(deepCloneData);
    this.bridge.callHandler('setMenuConfig', deepCloneData);
  },
  /**
   * 设置WebView页面右上角菜单展示/隐藏，
   * 证券业务webview通用方法，主要用于防止证券业务的马甲域名外露；
   * 默认只展示【消息】、【分享】、【刷新】几个操作项
   * @param {*} data 接受参数与[setMenuConfig]方法一致
   * @returns {[type]} [description]
   */
  setMenuConfigSafety: function setMenuConfigSafety(data) {
    var deepCloneData = (0, _toolBase.extend)({}, data || {}, true);
    var _this = this;

    // 下载jsBridge
    _this.initBridge({}, function () {
      // 默认配置，只展示【消息】、【分享】、【刷新】几个操作项
      var options = Object.assign({
        version: 1,
        // showType 默认为0，与native合并显示内容；若为1，则覆盖显示内容；
        showType: 1,
        // 显示在右上角的Menu
        actionMenu: {
          // 白名单: 需要展示的列表
          enable: [{
            // item名称, 对应上面的表
            name: 'more',
            // 展示位置，可以自定义，默认为0，按照上面的position值展示
            position: 10
          }, {
            // item名称, 对应上面的表
            name: 'search',
            // 展示位置，可以自定义，默认为0，按照上面的position值展示
            position: 20
          }],
          // 黑名单: 禁止展示的actionMenu列表；如果disable里有more, 则popupmenu内容不会被使用
          disable: []
        },
        // 三明治弹出窗口展示的列表
        popupMenu: {
          // 白名单: 三明治窗口 需要展示的列表
          enable: [{
            // item名称, 对应上面的表
            name: 'im',
            // 展示位置，可以自定义，默认为0，按照上面的position值展示
            position: 50
          }, {
            // item名称, 对应上面的表
            name: 'share',
            // 展示位置，可以自定义，默认为0，按照上面的position值展示
            position: 60
          }, {
            name: 'refresh',
            // 展示位置，可以自定义，默认为0，按照上面的position值展示
            position: 150
          }],
          disable: []
        }
      }, deepCloneData);
      _this.setMenuConfig(options);
    });
  },
  /**
   * 处理setMenuConfig的参数，绑定类型为custom的事件
   * @param {*} data setMenuConfig 未处理的参数
   */
  initSetMenuConfigData: function initSetMenuConfigData(data) {
    var actionMenu = data.actionMenu,
      popupMenu = data.popupMenu;
    var that = this;

    /**
     * 过滤出enable数组
     * @param {*} menuOrSandwichData 
     * @returns 
     */
    function filterEnableData(menuOrSandwichData) {
      if (menuOrSandwichData.enable) {
        return menuOrSandwichData.enable;
      }
      return [];
    }
    var actionMenuEnableData = filterEnableData(actionMenu);
    var popupMenuEnableData = filterEnableData(popupMenu);

    /**
     * 重置enable里面的custom选项数据
     * @param {*} enableData 
     */
    function resetEnableData(enableData) {
      if (!Array.isArray(enableData)) {
        throw new Error('resetEnableData: enable should be Array.');
      }
      enableData.forEach(function (item) {
        // 处理custom下面的action
        if (item.name === 'custom' && item.action && item.action.js_callback) {
          item.action.js_callback = that.registerHandler(item.action.js_callback);
        }
      });
    }
    resetEnableData(actionMenuEnableData);
    resetEnableData(popupMenuEnableData);
    return data;
  },
  /**
   * 注入js方法供客户端内部调用
   * @param {*} fun 
   * @param {*} name 自定义方法名 默认callback（通常无需要关心名称，这个名称只是给客户端调用的） 
   * @returns {String} 注册后的方法名称
   */
  registerHandler: function registerHandler(fun) {
    var name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'callback';
    var id = _genID();
    var uniqueName = "".concat(name, "_").concat(id);
    this.bridge.registerHandler(uniqueName, fun);
    return uniqueName;
  },
  /**
   * 设置WebView页面右上角菜单文本按钮
   * @param {*} data 
   */
  setMenuTextConfig: function setMenuTextConfig(data) {
    data = this.initMenuTextConfigData(data);
    this.bridge.callHandler('setMenuTextConfig', data);
  },
  /**
   * 处理setMenuTextConfig的参数
   * @param {*} data setMenuTextConfig 未处理的参数
   */
  initMenuTextConfigData: function initMenuTextConfigData(data) {
    var textMenu = data.textMenu;
    var action = textMenu.action;
    action.js_callback = this.registerHandler(action.js_callback);
    return data;
  },
  /**
   * 设置是否显示关闭按钮
   * @param {*} data 
   */
  setCloseButton: function setCloseButton(data) {
    this.bridge.callHandler('setCloseButton', data);
  },
  /**
   * 配置导航栏标题区域显示
   * @param {*} data 
   */
  setNavTitleConfig: function setNavTitleConfig(data) {
    this.bridge.callHandler('setNavTitleConfig', data);
  },
  /**
   * 获取第三方App安装状态
   * @param {*} data 传入数据，具体数据格式参考https://futu.feishu.cn/docx/Fhl1dQkvJoNrsIxnHAZcoPovnXe
   * @param {*} responseCallback 回调方法
   */
  getThirdPartyAppShareSupport: function getThirdPartyAppShareSupport(data, responseCallback) {
    this.bridge.callHandler('getThirdPartyAppShareSupport', (0, _cloneDeep["default"])(data), responseCallback);
  },
  /**
   * [loginDialog NNQ详情页中唤起登陆/取消弹出框]
   * @return {[type]} [description]
   */
  loginDialog: function loginDialog() {
    this.bridge.callHandler('callNativeLoginAction', {}, function (responseData) {});
  },
  /**
   * 控制搜索之后的tag定位
   * @param {Object} data 传给客户端的定位参数
   * @param {String} data.tab_type 传给客户端的tab定位参数
   * 协议链接 https://gitlab.futunn.com/echo/doc_sc/blob/master/nn_js_bridge/share_js_bridge.md#quickshare-jsbridge%E5%8D%8F%E8%AE%AE
   * 表示定位的tab参数 “composite”--综合tab、“stock”-行情tab、"news"-资讯tab、"nncircle"-牛牛圈tab、"friend"-牛友tab、"group"-牛牛群tab、"portfolio"-组合tab、"university"-课堂tab、"help"-帮助tab、"moo"-moomoo tab
   */
  openGlobalSearch: function openGlobalSearch(data) {
    this.bridge.callHandler('openGlobalSearch', data);
  },
  /**
   * 是否支持多图分享 setShowMultiImagesShare
   * @returns {boolean}
   */
  isSupportSetShowMultiImagesShare: function isSupportSetShowMultiImagesShare() {
    // 判断是否nn或mm
    if (!browser.isMobileNN()) {
      return false;
    }
    if (Utils.laterThanAndroid('10.22.1304')) {
      return true;
    }
    if (Utils.laterThanIOS('10.22.989')) {
      return true;
    }
    return false;
  },
  /**
   * [setShowMultiImagesShare 唤起多图分享功能] since 1.20.0
   * @param {Object} options
   * {
   *      // 图片数组，Array，必填，按从左至右顺序展示
   *      images: [{
   *          img: '', // 图片，String，必填，base64/url(必须带协议)
   *          title: '今日分享', // 图片标题，String，自行国际化
   *          isSelect: true, // 是否选中，Boolean，默认为false
   *      }],
   *      showType: 2,    // 展示类型，Number, 可选，默认为2，1: 多图单选，2：多图多选；
   *      enableChannel: 'wxTimeline', // 开启的分享渠道，可传字符串/数组，包括niuyou，chatRoom，nnq，wxFriend，wxTimeline，qq，weibo，facebook，twitter，字符串all代表所有渠道
   *      disableChannel:  ['wxTimeline', 'weibo'], // 屏蔽哪些分享途径，可传字符串/数组，包括niuyou，chatRoom，nnq，wxFriend，wxTimeline，qq，weibo，facebook，twitter，字符串all代表所有渠道
   * }
   * @return {Object} result
   * {
   *      "result": 0, // result 为0表示分享成功，为-1表示分享取消，其他为失败
   *      "channel": 'weibo', // channel 为用户点击的分享渠道
   *      "selectedIndex": [0, 3, 1] // selectedIndex 为用户选中的图片索引数组
   * }
   * 客户端接口协议：http://gitlab.futunn.com/echo/doc_sc/blob/master/nn_js_bridge/share_js_bridge.md#setshowmultiimagesshare-jsbridge%E5%8D%8F%E8%AE%AE
   */
  setShowMultiImagesShare: function setShowMultiImagesShare(options, successCallback, failCallback) {
    if (!this.isSupportSetShowMultiImagesShare()) {
      return false;
    }
    var that = this;

    // 参数检查
    if (!Array.isArray(options.images)) {
      throw new Error('setShowMultiImagesShare: options.images should be Array.');
    }
    if (options.showType != undefined && typeof options.showType !== 'number') {
      throw new Error('setShowMultiImagesShare: options.showType should be Number.');
    }

    // 处理参数
    var id = _genID();
    var getImgFnName = 'fetchImageBase64ByID_' + id;
    var imagesMap = {}; // 图片缓存
    var config = {
      version: 1,
      // 预留字段
      showType: options.showType || 2,
      // 1: 多图单选 2：多图多选
      images: [],
      enableChannel: filterChannel(options.enableChannel),
      disableChannel: filterChannel(options.disableChannel),
      fetchImageJSFunc: getImgFnName
    };
    config.images = options.images.map(function (item, index) {
      var imgId = id + '_' + index;
      var data = item.img;
      imagesMap[imgId] = item;
      return {
        img: _isBase64(data) ? imgId : data,
        title: item.title,
        isSelect: item.isSelect === true ? 0 : 1
      };
    });
    // 处理selectMax参数，安卓没有加这个参数，ios<=10.22.996有这个参数，现在统一移除此参数，这里针对ios做兼容处理。
    if (browser.isIOS()) {
      config.selectMax = options.images.length;
    }

    // 提前注册好供客户端异步获取图片的方法
    var getImgFn = function getImgFn(data, responseCallback) {
      var imgItem = data && imagesMap[data];
      if (typeof responseCallback === 'function') {
        var res = imgItem && imgItem.img;
        responseCallback(res || '');
      }
    };
    that.bridge.registerHandler(getImgFnName, getImgFn);

    // 调用app的分享
    that.bridge.callHandler('setShowMultiImagesShare', config, function (responseData) {
      if (typeof responseData === 'string') {
        try {
          responseData = JSON.parse(responseData);
        } catch (err) {
          console.error('setShowMultiImagesShare: 客户端响应解析失败');
          typeof failCallback === 'function' && failCallback({
            code: 500,
            data: responseData,
            msg: '客户端响应解析失败'
          });
          return false;
        }
      }
      if (responseData.channel) {
        responseData.channel = _findChannelById(responseData.channel);
      }
      // 兼容ios返回的是selected_index
      if (!responseData.selectedIndex && responseData.selected_index) {
        responseData.selectedIndex = responseData.selected_index;
      }
      if (+responseData.result === 0) {
        typeof successCallback === 'function' && successCallback(responseData);
      } else {
        typeof failCallback === 'function' && failCallback(responseData);
      }
    });
  },
  /**
   * [showDiverseShare 唤起多类分享功能]
   * @param {Object} options
   * @param {*} successCallback 
   * @param {*} failCallback 
   * options的选项
   * {
   *      // 分享类型，Number类型，必传
   *      // 1: 多图单选  2: 多图多选  3: 单图单选（快照分享）  4: 结构化数据
   *      // 5: 快速分享 快速分享可以理解为只支持一个渠道的分享，因此需要快速分享只需把showType设为5，enable_channel字段指定具体的**一个**渠道
   *      // 6: 同时分享图片和结构化数据,默认展示结构化数据 7: 同时分享图片和结构化数据,默认展示图片
   *      show_type: 6,
   *      // 开启的分享渠道，可传字符串/数组，取值为http://fservice.server.com/repository/project/1190057/proto-space/4691/main/-/setShareConfig.md?method_branch=main channel定义的key值，字符串all代表所有渠道
   *      enable_channel: 'wxTimeline',
   *      // 开启渠道和屏蔽渠道只能二选一
   *      // 屏蔽哪些分享途径，可传字符串/数组，取值为http://fservice.server.com/repository/project/1190057/proto-space/4691/main/-/setShareConfig.md?method_branch=main channel定义的key值，字符串all代表所有渠道
   *      disable_channel:  ['wxTimeline', 'weibo'], 
   *      // 要求客户端分享时，弹窗中展示“积分金币”。false表示不展示，true表示展示，默认不展示。
   *      show_coin_status: true, 
   *      // 指定链接分享的结构化数据
   *      "share_data": {
   *          // 默认的分享配置，必传
   *          "common_model": {
   *              // 资讯标题
   *              "title": "标题",
   *              // 摘要
   *              "description": "这个是新闻摘要",
   *              // 跳转链接
   *              "url": "https://news.futunn.com/market/118221?src=3",
   *              // 图片，只支持网络图片，不支持base64
   *              "image_url": "https://postimg.futunn.com/2019080700000038e0bcca3d36b.jpg",
   *              // 自定义补充数据,非必传
   *              "ext": "额外数据",
   *              // 上报类型，Number类型，1-个股资讯 2-新闻资讯，可不传
   *              "link_type": 1
   *          },
   *          // 渠道定制的分享配置（非必传），目前仅在show_type=4时生效。
   *          "share_model_list": [
   *              {
   *                  // 资讯标题
   *                  "title": "标题",
   *                  // 描述
   *                  "description": "这个是新闻摘要",
   *                  // 跳转链接
   *                  "url": "https://news.futunn.com/market/118221?src=3",
   *                  // 分享图片地址，只支持网络图片，不支持base64
   *                  "image_url": "https://postimg.futunn.com/2019080700000038e0bcca3d36b.jpg",
   *                  // 自定义补充数据
   *                  "ext": "额外数据",
   *                  // 分享渠道，可传字符串/数组，取值为http://fservice.server.com/repository/project/1190057/proto-space/4691/main/-/setShareConfig.md?method_branch=main channel定义的key值，字符串all代表所有渠道
   *                  "channel": ['wxTimeline', 'weibo'],
   *              }
   *          ]
   *      },
   *      // 指定图片分享的配置
   *      "share_image": {
   *          // 图片数组，按从左至右顺序展示，当是单图分享时，images数组传一个元素
   *          "images": [{
   *              // 图片，String，必填，base64/url(必须带协议)
   *              img: '', 
   *              // 图片标题，String，自行国际化
   *              title: '今日分享', 
   *              // 多图分享中指定图片是否选中，Boolean，默认为false
   *              is_select: true, 
   *          }],
   *      }
   * }
   * @return {Object} [分享成功或失败的回调结果]
   * {
   *      // result 为0表示分享成功，为-1表示分享取消，其他为失败
   *      "result": 0,       
   *      // channel 为用户点击的分享渠道 
   *      "channel": 'weibo', 
   *      // selected_img_index 为用户选中的图片索引数组，只在用户选择图片分享时返回；可以通过有没有返回此字段来判断用户选择了图片分享还是链接分享。
   *      "selected_img_index": [0, 3, 1] 
   * }
   * 客户端接口协议：http://gitlab.futunn.com/echo/doc_sc/blob/master/nn_js_bridge/share_js_bridge.md#%E6%94%AF%E6%8C%81%E5%A4%9A%E7%A7%8D%E5%88%86%E4%BA%AB%E7%B1%BB%E5%9E%8B
   */
  showDiverseShare: function showDiverseShare(sourceOptions, successCallback, failCallback) {
    var options = (0, _cloneDeep["default"])(sourceOptions);
    // 参数校验
    if (!successCallback) {
      successCallback = function successCallback() {};
    }
    if (!failCallback) {
      failCallback = function failCallback() {};
    }
    if (!options.show_type) {
      return failCallback({
        result: 500,
        msg: 'show_type 参数是必传'
      });
    }
    var params;
    // 新协议的 setShowShare
    if (this.isSupportShareV3()) {
      params = this._formatParamsForShareV3(options);
      // 调用app的接口
      this.bridge.callHandler('setShowShare', params, function (responseData) {
        if (typeof responseData === 'string') {
          try {
            responseData = JSON.parse(responseData);
          } catch (err) {
            console.error('setShowShare: 客户端响应解析失败');
            failCallback({
              result: 500,
              data: responseData,
              msg: '客户端响应解析失败'
            });
            return false;
          }
        }
        if (responseData.channel) {
          responseData.channel = _findChannelById(responseData.channel);
        }
        if (+responseData.result === 0) {
          successCallback(responseData);
        } else {
          failCallback(responseData);
        }
      });
      // 兼容多图分享
    } else if (options.show_type == 1 || options.show_type == 2) {
      if (this.isSupportSetShowMultiImagesShare()) {
        params = Utils._formatParamsForMultiShare(options, successCallback, failCallback);
        var _config = params._config;
        delete params._config;
        this.setShowMultiImagesShare(params, _config.success, _config.fail);
      } else {
        failCallback({
          result: 400,
          msg: '当前app版本不支持多图分享'
        });
      }
      // 兼容快照分享
    } else if (options.show_type == 3) {
      if (_nn["default"].isSupportSnapshot()) {
        params = Utils._formatParamsForSnapshot(options, successCallback, failCallback);
        var channelOptions = params.channelOptions;
        delete params.channelOptions;
        _nn["default"].configSnapshot(params);
        setTimeout(function () {
          _nn["default"].showSnapshotShare(channelOptions);
        }, 300);
      } else {
        failCallback({
          result: 400,
          msg: '当前app版本不支持快照分享'
        });
      }
      // 兼容结构化数据分享
    } else if (options.show_type == 4) {
      if (_nn["default"].isSupportShareV2()) {
        params = Utils._formatParamsForShowShareV2(options, successCallback, failCallback);
        params._findChannelById = _findChannelById;
        var _config2 = params._config;
        delete params._config;
        this.showShareV2.call(this, params, _config2.success, _config2.fail);
        // 兼容旧版本结构化数据分享
      } else {
        params = Utils._formatParamsForShowShare(options, successCallback, failCallback);
        _nn["default"].showShare(params);
      }
      // 兼容快速分享
    } else if (options.show_type == 5) {
      if (_nn["default"].isSupportQuickShare()) {
        params = Utils._formatParamsForQuickShare(options);
        _nn["default"].quickShare(params);
      } else {
        failCallback({
          result: 400,
          msg: '当前app版本不支持快速分享'
        });
      }
      // 当前版本不支持同时分享图片和结构化数据
    } else {
      failCallback({
        result: 400,
        msg: '当前app版本不支持新版分享'
      });
    }
  },
  /**
   * [setDiverseShareConfig 设置分享的配置（右上角菜单），参数和返回与 showDiverseShare 类似（show_type只支持4，不支持share_image）]
   * TODO：2021-02-05 不接入这个协议
   * @private
   * @param {*} options 
   * @param {*} successCallback 
   * @param {*} failCallback 
   * options的选项
   * {
   *      // 分享类型，Number类型，必传，目前只支持结构化数据分享的配置
   *      // 4: 结构化数据
   *      show_type: 4,
   *      // 开启的分享渠道，可传字符串/数组，取值为http://fservice.server.com/repository/project/1190057/proto-space/4691/main/-/setShareConfig.md?method_branch=main channel定义的key值，字符串all代表所有渠道
   *      enable_channel: 'wxTimeline',
   *      // 开启渠道和屏蔽渠道只能二选一
   *      // 屏蔽哪些分享途径，可传字符串/数组，取值为http://fservice.server.com/repository/project/1190057/proto-space/4691/main/-/setShareConfig.md?method_branch=main channel定义的key值，字符串all代表所有渠道
   *      disable_channel:  ['wxTimeline', 'weibo'], 
   *      // 要求客户端分享时，弹窗中展示“积分金币”。false表示不展示，true表示展示，默认不展示。
   *      show_coin_status: true, 
   *      // 指定链接分享的结构化数据
   *      "share_data": {
   *          // 默认的分享配置，必传
   *          "common_model": {
   *              // 资讯标题
   *              "title": "标题",
   *              // 摘要
   *              "description": "这个是新闻摘要",
   *              // 跳转链接
   *              "url": "https://news.futunn.com/market/118221?src=3",
   *              // 图片
   *              "image_url": "https://postimg.futunn.com/2019080700000038e0bcca3d36b.jpg",
   *              // 自定义补充数据,非必传
   *              "ext": "额外数据",
   *              // 上报类型，Number类型，1-个股资讯 2-新闻资讯，可不传
   *              "link_type": 1
   *          },
   *          // 渠道定制的分享配置（非必传），目前仅在show_type=4时生效。
   *          "share_model_list": [
   *              {
   *                  // 资讯标题
   *                  "title": "标题",
   *                  // 描述
   *                  "description": "这个是新闻摘要",
   *                  // 跳转链接
   *                  "url": "https://news.futunn.com/market/118221?src=3",
   *                  // 分享图片地址
   *                  "image_url": "https://postimg.futunn.com/2019080700000038e0bcca3d36b.jpg",
   *                  // 自定义补充数据
   *                  "ext": "额外数据",
   *                  // 分享渠道，可传字符串/数组，取值为http://fservice.server.com/repository/project/1190057/proto-space/4691/main/-/setShareConfig.md?method_branch=main channel定义的key值，字符串all代表所有渠道
   *                  "channel": ['wxTimeline', 'weibo'],
   *              }
   *          ]
   *      },
   * }
   * @return {Object} [分享成功或失败的回调结果]
   * {
   *      // result 为0表示分享成功，为-1表示分享取消，其他为失败
   *      "result": 0,       
   *      // channel 为用户点击的分享渠道 
   *      "channel": 'weibo', 
   *      // selected_img_index 为用户选中的图片索引数组，只在用户选择图片分享时返回；可以通过有没有返回此字段来判断用户选择了图片分享还是链接分享。
   *      "selected_img_index": [0, 3, 1] 
   * }
   */
  setDiverseShareConfig: function setDiverseShareConfig(options, successCallback, failCallback) {
    // 参数校验
    if (!successCallback) {
      successCallback = function successCallback() {};
    }
    if (!failCallback) {
      failCallback = function failCallback() {};
    }
    if (!options.show_type) {
      return failCallback({
        result: 500,
        msg: 'show_type 参数是必传'
      });
    }
    var params;
    // 新协议的 setShowShare
    if (this.isSupportShareV3()) {
      params = this._formatParamsForShareV3(options);
      // 调用app的接口
      this.bridge.callHandler('setShareConfig', params, function (responseData) {
        if (typeof responseData === 'string') {
          try {
            responseData = JSON.parse(responseData);
          } catch (err) {
            console.error('setShareConfig: 客户端响应解析失败');
            failCallback({
              result: 500,
              data: responseData,
              msg: '客户端响应解析失败'
            });
            return false;
          }
        }
        if (responseData.channel) {
          responseData.channel = _findChannelById(responseData.channel);
        }
        if (+responseData.result === 0) {
          successCallback(responseData);
        } else {
          failCallback(responseData);
        }
      });
      // 兼容结构化数据分享配置
    } else if (options.show_type == 4) {
      if (_nn["default"].isSupportShareV2()) {
        params = Utils._formatParamsForShowShareV2(options, successCallback, failCallback);
        params._findChannelById = _findChannelById;
        var _config = params._config;
        delete params._config;
        this.configV2.call(this, params, _config.success, _config.fail);
        // 兼容旧版本结构化数据分享配置
      } else {
        params = Utils._formatParamsForShowShare(options, successCallback, failCallback);
        _nn["default"].config(params);
      }
      // 当前版本不支持其他类型的分享配置
    } else {
      failCallback({
        result: 400,
        msg: '当前app版本不支持此类型的分享配置'
      });
    }
  },
  /**
   * 是否支持新的分享接口： 可以用于判断是否支持showDiverseShare和setDiverseShareConfig
   * 安卓>=11.4.1407        ios>=11.4.1207
   * @return {Boolean}
   */
  isSupportShareV3: function isSupportShareV3() {
    // 判断是否nn或mm
    if (!browser.isMobileNN()) {
      return false;
    }
    if (Utils.laterThanAndroid('11.4.1407')) {
      return true;
    }
    if (Utils.laterThanIOS('11.4.1207')) {
      return true;
    }
    return false;
  },
  /**
   * 为新的分享协议 格式化参数
   * @private
   * @param {Object} options 选项参数
   * @return {Object}
   */
  _formatParamsForShareV3: function _formatParamsForShareV3(options) {
    // 格式化 share_data
    if (options.share_data && options.share_data.share_model_list) {
      options.share_data.share_model_list.forEach(function (item) {
        item.channel = filterChannel(item.channel);
      });
    }

    // 格式化 share_image
    if (options.share_image && options.share_image.images) {
      var id = _genID();
      var getImgFnName = 'fetchBase64ByIdV3_' + id;
      var imagesMap = {}; // 图片缓存
      options.share_image.images = options.share_image.images.map(function (item, index) {
        var imgId = id + '_' + index;
        var data = item.img;
        imagesMap[imgId] = item;
        return {
          img: _isBase64(data) ? imgId : data,
          title: item.title,
          is_select: item.is_select === true ? 0 : 1
        };
      });
      options.share_image.fetch_image_js_func = getImgFnName;
      // 提前注册好供客户端异步获取图片的方法
      var getImgFn = function getImgFn(data, responseCallback) {
        var imgItem = data && imagesMap[data];
        if (typeof responseCallback === 'function') {
          var res = imgItem && imgItem.img;
          responseCallback(res || '');
        }
      };
      if (this.bridge && this.bridge.registerHandler) {
        this.bridge.registerHandler(getImgFnName, getImgFn);
      } else {
        window[getImgFnName] = getImgFn;
      }
    }
    var enable = filterChannel(options.enable_channel);
    var disabled = filterChannel(options.disable_channel);
    // 配置
    var config = {
      version: 1,
      show_type: options.show_type || 6,
      enable: enable ? enable : undefined,
      disabled: disabled ? disabled : undefined,
      show_coin_status: options.show_coin_status === true ? 1 : 0,
      share_data: options.share_data,
      share_image: options.share_image
    };
    return config;
  },
  /**
   * 是否支持口令分享
   * @return {Boolean}
   */
  isSupportPassShare: Utils.isSupportPassShare
};
// 引入组件就执行一次，兼容ios注册NNWebViewJSBridge，再次刷新页面时的报错问题
NNQ.initBridge();
var _default = exports["default"] = NNQ;
module.exports = exports.default;